<template>
  <div id="detail" class="oma-page">
    <div style="text-align: center;">
      <img
        src="@/assets/serviceImg/service/Frame_4108@2x(6).png"
        alt="海外就医安排"
        class="oma-banner-img"
      />
    </div>

    <section class="oma-section">
      <div class="oma-section-title">服务介绍</div>
      <div class="oma-section-content">{{ pageCopy.intro }}</div>
    </section>

    <section class="oma-section">
      <div class="oma-section-title">核心服务</div>
      <ul class="oma-service-list">
        <li v-for="item in pageCopy.coreServices" :key="item">{{ item }}</li>
      </ul>
    </section>

    <section class="oma-section">
      <div class="oma-section-title">所需材料</div>
      <div class="oma-section-content">{{ pageCopy.materials }}</div>
    </section>

    <section class="oma-section">
      <div class="oma-section-title">使用规则</div>
      <ul class="oma-rule-list">
        <li v-for="item in pageCopy.rules" :key="item">{{ item }}</li>
      </ul>
    </section>

    <section class="oma-section">
      <div class="oma-section-title">使用方式</div>
      <div class="oma-section-content">
        {{ pageCopy.usageBefore }}
        <a :href="hotlineTel" class="oma-hotline-link">{{ hotlineDisplay }}</a>
        {{ pageCopy.usageAfter }}
      </div>
    </section>

    <div class="oma-action-bar">
      <button
        type="button"
        class="oma-action-btn"
        :class="{ 'oma-action-btn--disabled': !equityCanUse }"
        :disabled="!equityCanUse"
        @click="makeanappointment"
      >{{ getServiceBtnText }}</button>
    </div>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p class="modal-tip">该项权益需开通以下服务权益</p>
        <div class="modal-card" @click="equity">
          <img class="modal-card-bg" src="@/assets/img/qykbj.png" alt="" />
          <h3 class="modal-card-title">大救星-星健康权益卡</h3>
          <div class="modal-card-desc">多项健康权益尊享，为您健康守护</div>
          <div class="modal-card-btn">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaiheServiceCopy } from '@/utils/taiheServiceCopy'
import equityUsedCountMixin from '@/mixins/equityUsedCountMixin'

/** 24 小时救援热线 */
const RESCUE_HOTLINE_DISPLAY = '+86-10-89180868'
const RESCUE_HOTLINE_TEL = 'tel:+861089180868'

/** 海外就医安排统一展示文案 */
const OVERSEAS_MEDICAL_ARRANGEMENT_COPY = Object.freeze({
  intro:
    '为确诊心血管疾病用户提供海外高端医疗协助，对接美、德、英、日等国顶级医院，全程协助办理就医相关事宜，提供一站式海外就诊支持。',
  coreServices: [
    '海外医院与专家推荐',
    '病历收集、翻译及传递',
    '海外就诊预约与邀请函办理',
    '签证、机票、住宿协助',
    '境外接送机、就医及生活翻译陪同',
    '全程医疗费用支付指导'
  ],
  materials:
    '实名身份信息、心血管疾病确诊病历、检查报告、诊断证明等完整医学资料，及个人相关授权信息。',
  rules: [
    '下载【大救星健康版】APP，实名注册开通服务，经确诊并通过资格审核；',
    '服务范围：覆盖美国、德国、英国、日本等海外顶级医院；',
    '服务时效：申请后2个工作日响应，资料齐全后7个工作日完成病历整理翻译，15个工作日确认预约；',
    '使用次数：合同有效期内限本人使用1次，翻译医疗病例前未提前取消将扣减此次权益；',
    '备注：第三方费用、医疗、交通、翻译等费用均由用户自理。'
  ],
  usageBefore: '登录【大救星健康版】APP一键救援，或拨打24小时热线 ',
  usageAfter: '提交需求；专员审核资格与资料，协调海外机构安排就诊，全程跟进直至服务完成。'
})

export default {
  equityServiceKey: 'overseasMedicalArrangement',
  mixins: [equityUsedCountMixin],
  data() {
    return {
      showModal: false,
      equityinfoType: false,
      hotlineDisplay: RESCUE_HOTLINE_DISPLAY,
      hotlineTel: RESCUE_HOTLINE_TEL
    }
  },
  computed: {
    /**
     * 根据 productId 返回海外就医安排页面文案（保留 id 判断，当前各 id 统一展示同一套文案）
     * @returns {{ intro: string, coreServices: string[], materials: string, rules: string[], usageBefore: string, usageAfter: string }}
     */
    pageCopy() {
      const productId = this.$route.query.productId
      if (productId === '949' || productId === 949) {
        return OVERSEAS_MEDICAL_ARRANGEMENT_COPY
      }
      getTaiheServiceCopy(productId, 'overseasMedicalArrangement', OVERSEAS_MEDICAL_ARRANGEMENT_COPY.intro)
      return OVERSEAS_MEDICAL_ARRANGEMENT_COPY
    }
  },
  created() {
    document.title = '海外就医安排'
    this.equityinfoType = localStorage.getItem('equityinfo')
  },
  beforeCreate() {
    document.querySelector('#app').setAttribute('style', 'background-color:#F2F3F5')
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px'
    }
  },
  methods: {
    /**
     * 获取服务：校验剩余次数后跳转一键救援
     */
    makeanappointment() {
      this.goRescueWithCaseType()
    },
    /**
     * 跳转权益卡介绍
     */
    equity() {
      this.$router.push({
        path: '/equity',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="less">
.oma-page {
  min-height: 100vh;
  padding: 1rem 0.5rem calc(76px + env(safe-area-inset-bottom));
  background: #f2f3f5;
  box-sizing: border-box;
}

.oma-banner-img {
  width: 100px;
  height: 100px;
  vertical-align: middle;
  margin-right: 0.5vw;
  margin-bottom: 1rem;
}

.oma-section {
  margin-bottom: 12px;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.oma-section-title {
  position: relative;
  padding-left: 10px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  line-height: 1.3;
}

.oma-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #00c275 0%, #4ecdc4 100%);
}

.oma-section-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.75;
  text-align: justify;
}

.oma-hotline-link {
  color: #00bb82;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.oma-hotline-link:active {
  opacity: 0.75;
}

.oma-service-list,
.oma-rule-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.oma-service-list li,
.oma-rule-list li {
  position: relative;
  padding-left: 14px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 1.65;
}

.oma-service-list li::before,
.oma-rule-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00c275;
}

.oma-service-list li:last-child,
.oma-rule-list li:last-child {
  margin-bottom: 0;
}

.oma-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(242, 243, 245, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.oma-action-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: rgb(0, 187, 130);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.oma-action-btn:active {
  opacity: 0.9;
  transform: scale(0.99);
}

.oma-action-btn--disabled,
.oma-action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.modal {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.modal-tip {
  margin: 0 0 20px;
  font-size: 15px;
  color: #333333;
  text-align: center;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: #000000;
  cursor: pointer;
}

.modal-card {
  position: relative;
  height: 160px;
  overflow: hidden;
  border-radius: 12px;
}

.modal-card-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-card-title {
  position: absolute;
  top: 56px;
  left: 24px;
  margin: 0;
  font-size: 18px;
  color: #333333;
}

.modal-card-desc {
  position: absolute;
  top: 88px;
  left: 24px;
  font-size: 13px;
  color: #666666;
}

.modal-card-btn {
  position: absolute;
  top: 56px;
  right: 16px;
  width: 72px;
  height: 28px;
  border-radius: 16px;
  background: rgb(74, 71, 64);
  color: #f2d57a;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/detailsH5/overseasMedicalArrangement.vue